import React from "react";
import Footer from "./Essentials/Footer";
import Navbar from "./Essentials/Navbar";
import { useLocation } from "react-router-dom";

function Missions() {
  const router = useLocation();

  return (
    <>

      <Navbar />
      <center>
        <br />
        <b style={{
          color: "#024369",
          fontSize: "1.3rem",
          borderBottom: "3px solid lightblue",
          width: "max-content"
        }}>Our Missions</b><br />
        <img width={window.screen.width > 750 ? "20%" : "40%"} src="NFRAC-png.png" />
        <center
          style={{
            textAlign: "left",
            width: window.screen.width > 750 ? "60%" : "90%",
            textAlign: "justify"
          }}
          id="missions"
        >
          <p>
            <b>Pledge : </b> "As s Computing Professional, I pledge to practice my
            profssion with the highest level of integrity and competence, I shall
            always use my skills for the public good. I shall be honest about my
            limitations, continuously seeking to improve my skills through
            life-long learning."
          </p>
          <br />
          <p>
            &#x2022;&nbsp; Our team is intended to harness the tremendous computational power of the systems and to use it to serve the technological needs for the current and future generations, for the betterment of mankind. This will lead to an international collaboration on a smaller scale working together which yields good results using computer science. We aim to solve the problems using the knowledge we gain from the computer science domain.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; To boost the ability to apply knowledge of computing and
            mathematics appropriate to the discipline.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; Escalate the ability to identify, formulate, and
            develop solutions to computational challenges.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; Thrive to design, implement, and evaluate a
            computational system to meet desired needs within realistic
            constraints.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; Designing of advanced algorithms for the betterment of medical research, defence research, space research and educational purposes.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; An understanding of professional, ethical, legal,
            security, and social issues and responsibilities for the computing
            profession.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; Should be able to function effectively on teams to
            accomplish shared computing design, evaluation, or implementation
            goals.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; Emphasize on the ability to analyze impacts of
            computing on individuals, organizations, and society.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; Recognition of the need for and ability to engage in
            continuing professional development.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; Apply design and development principles in the
            construction of software systems of varying complexity.
          </p>
          <br />
          <p>
            &#x2022;&nbsp;Applying mathematical foundations, algorithmic
            principles, and computer science theory in the modeling and design of
            computational systems and advanced algorithms in a way that demonstrates comprehension of the
            tradeoffs involved in design choices.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; It is a life-long learning: We recognize the need for,
            and have the preparation and ability to engage in independent and
            life-long learning in the broadest context of technological change.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; We apply critical thinking skills to provide
            sustainable solutions and analyse its effect on environment.
          </p>
          <br />
          <p>
            &#x2022;&nbsp; We pursue independent study and demonstrate the
            capabilities for lifelong learning and professional development
          </p>
          <br />
        </center>
      </center>
      <Footer />
    </>
  );
}

export default Missions;
